import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export default class Footer {
  $main = $(".main-footer");
  $sub = $(".sub-footer");

  constructor() {}
}
